import { USER_ROLES, WEBBACK_V2_API } from "@constants"
import { useUserApp } from "@hooks"

const V2_PRICING = `${WEBBACK_V2_API}/pricing`

// **Neither url depends on the role any more — but the back has two tables, not one.** v1 branches
// both bases: a retailer got `/market-analyzer-retailers` for the charts and `/pricing-retailers`
// for the table. v2 kept the split only where it is real:
//
// - the **charts** are one endpoint for both roles, because their contract is identical and only
//   the bucket labels change (Meet/Beat/Lose against Same/Above/Below RRSP). `reference_price.py`
//   decides from the user's role;
// - the **table** keeps its own endpoint, because the retailer variant answers ~15 different keys
//   (`myActualPrice`, `myStock`, `stockCompetition`, `minSite`…). Unify where the contract is the
//   same, separate where there are two — §6.3 of
//   dipi-webback-v2/plans/869e5pfw2--data-market-analyzer.md.
//
// So the role picks the table's base url and nothing else. Both variants are regressed against
// their own half of v1.
//
// The MARKETPLACES branch is dropped rather than ported: that role is out of scope and is not
// coming back. It pointed at the same urls as STANDARD anyway.

export default function useMarketAnalyzerRoleConfig() {
	const { userRole, userUseRRSP } = useUserApp()
	const isRetailerUser = userRole === USER_ROLES.RETAILER

	return {
		userRole,
		// The table, its Excel and the SKU drill-down live in the `pricing-and-discount` nested;
		// only the two share charts are under `market-analyzer`. That split is v1's and v2 kept it.
		urlApiTable: isRetailerUser
			? `${V2_PRICING}/pricing-retailers`
			: `${V2_PRICING}/pricing-and-discount`,
		urlApiChart: `${V2_PRICING}/market-analyzer`,
		isRetailerUser,
		isStandardUser: userRole === USER_ROLES.STANDARD,
		userUseRRSP: userUseRRSP
	}
}
